import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./MisComentarios.module.scss";
import EmptyStateComments from "../../../UI/EmptyState/EmptyStateComments";
import { connect } from "react-redux";
import RepAndComments from "./RepAndComments/RepAndComments";
import { ReactComponent as StarFull } from "../../../../assets/svg/starFullSvg.svg";
import { ReactComponent as ArrowDownIcon } from "../../../../assets/svg/arrowDownIcon.svg";
import {openCalificationModal, getCalificationsByUser } from "../../../../store/actions";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";

const MisComentarios = ({
  perfilAjeno,
  myPerson,
  commentsProfile,
  profileVisualizerData,
  comments,
  openCalificationModal,
  userCalifications,
  userCalificationsLoading,
  getCalificationsByUser,
  setInfoReady,
  ...props }) => {
  const [orderBy, setOrderBy] = useState({ value: "fecha", label: "Fecha" });
  const [rubro, setRubro] = useState({ value: "service", label: "Rubro contratado" });
  const [calificacion, setCalificacion] = useState({value: "Calificación", label: "Calificación"});
  const [isFiltered, setIsFiltered] = useState(false);
  const [commentsFiltered, setCommentsFiltered] = useState([]);
  const [optionsVisibility, setOptionsVisibility] = useState({
    orderBy: false,
    rubro: false,
    calificacion: false
  });

  useEffect(() => {
    if (!userCalificationsLoading && userCalifications !== undefined) {
      setInfoReady(true);
    }
  }, [userCalificationsLoading, userCalifications, setInfoReady]);

  const handleOrderByChange = (value, label) => {
    setOrderBy({value, label});
    toggleOptionsVisibility("orderBy");
    handleSortByDate(value);
  };

  const handleRubroChange = (value, label) => {
    setRubro({value, label});
    toggleOptionsVisibility("rubro");
    handleFilterByRubro(value);
  };

  const handleCalificacionChange = (value, label) => {
    setCalificacion({ value, label });
    toggleOptionsVisibility("calificacion");
    handleFilterComments(value);
  };
  
  
  const toggleOptionsVisibility = (option) => {
    setOptionsVisibility(prevState => ({
      ...prevState,
      [option]: !prevState[option]
    }));
  };

  const orderByOptions = [
    { value: "fecha", label: "Fecha" },
    { value: "masRecientes", label: "Más recientes" },
    { value: "masAntiguos", label: "Más antiguos" }
  ];

  const handleSortByDate = useCallback((value) => {
    if (value === "fecha") {
      setIsFiltered(false);
      setCommentsFiltered([]);
      return;
    }

    const source = isFiltered ? [...commentsFiltered] : [...(userCalifications || [])];
    const sorted =
      value === "masRecientes"
        ? source.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        : source.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    setCommentsFiltered(sorted);
    setIsFiltered(true);
  }, [commentsFiltered, isFiltered, userCalifications]);

  useEffect(() => {
    if (orderBy.value !== "fecha") {
      handleSortByDate(orderBy.value);
    }
  }, [orderBy, handleSortByDate]);

  const groupByRubros = useMemo(() => {
    const grouped = {};

    if (!Array.isArray(userCalifications)) {
        return grouped;
    }

    userCalifications.forEach(calif => {

        if (Array.isArray(calif.skills)) {
            calif.skills.forEach(skill => {
                const rubro = skill?.skill?.name;

                if (rubro) {
                    grouped[rubro] = (grouped[rubro] || 0) + 1;
                }
            });
        }
    });
    
    return grouped;
  }, [userCalifications]);

  const rubroOptions = useMemo(() => [
    { value: "service", label: "Rubro contratado" },
    ...Object.entries(groupByRubros).map(([rubro, count]) => (
      { value: rubro, label: `${rubro} (${count})` }
    ))
  ], [groupByRubros]);


  const groupByStars = useMemo(() => {
    const grouped = {};

    if (!Array.isArray(userCalifications)) {
      return grouped;
    }
    
    userCalifications.forEach(calif => {
      const stars = calif.stars;
      if (!grouped[stars]) {
        grouped[stars] = 1;
      } else {
        grouped[stars]++;
      }
    });
    return grouped;
  }, [userCalifications]);

  const calificacionOptions = useMemo(() => [
    { value: "Calificación", label: "Calificación" },
    ...Object.entries(groupByStars).map(([stars, count]) => (
      { value: `calificacion${stars}`, label: <><StarFull height={15} width={15} /> {stars} ({count})</> }
    ))
  ], [groupByStars]);

  const handleFilterComments = useCallback((value) => {
    if (value === "Calificación") {
      setIsFiltered(false);
      return;
    }
    
    setIsFiltered(true);
    const calificacionNumber = parseInt(value.replace("calificacion", ""), 10);
    setCommentsFiltered(userCalifications.filter(comment => comment.stars === calificacionNumber));
    
  }, [userCalifications]);

  const handleFilterByRubro = useCallback((value) => {
    if (value === "service") {
      setIsFiltered(false);
      return;
    }

    setIsFiltered(true);
    setCommentsFiltered(userCalifications.filter(comment =>
      comment.skills.some(skill => skill.skill.name === value)
  ));
  }, [userCalifications]);

  useEffect(() => {
    if (rubro.value !== "service") {
      handleFilterByRubro(rubro.value);
    }
  }, [rubro, handleFilterByRubro]);

  useEffect(() => {
    if (calificacion.value !== "Calificación") {
      handleFilterComments(calificacion.value);
    } 
  }, [calificacion, handleFilterComments]);

  useEffect(() => {
    getCalificationsByUser(parseInt(perfilAjeno));
  }, [perfilAjeno, getCalificationsByUser]);

  return (
    <div className={styles.container}>
      <main className={styles.panel}>
        <header className={styles.header}>
          <div className={styles.filters}>
            <button
              type="button"
              className={`${styles.filterButton} ${optionsVisibility.orderBy ? styles.filterButtonActive : ""}`}
              onClick={() => toggleOptionsVisibility("orderBy")}
            >
              <span>{orderBy.label === "fecha" ? "Fecha" : orderBy.label}</span>
              <ArrowDownIcon width={12} height={12} />
              {optionsVisibility.orderBy && (
                <div className={styles.popover}>
                  {orderByOptions.map((option) => (
                    <div
                      key={option.value}
                      className={styles.popoverItem}
                      onClick={() => handleOrderByChange(option.value, option.label)}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </button>
            <button
              type="button"
              className={`${styles.filterButton} ${optionsVisibility.rubro ? styles.filterButtonActive : ""}`}
              onClick={() => toggleOptionsVisibility("rubro")}
            >
              <span>{rubro.label === "service" ? "Rubro contratado" : rubro.label}</span>
              <ArrowDownIcon width={12} height={12} />
              {optionsVisibility.rubro && (
                <div className={styles.popover}>
                  {rubroOptions.map((option) => (
                    <div
                      key={option.value}
                      className={styles.popoverItem}
                      onClick={() => handleRubroChange(option.value, option.label)}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </button>
            <button
              type="button"
              className={`${styles.filterButton} ${optionsVisibility.calificacion ? styles.filterButtonActive : ""}`}
              onClick={() => toggleOptionsVisibility("calificacion")}
            >
              <span>{calificacion.label === "Calificación" ? "Calificación" : calificacion.label}</span>
              <ArrowDownIcon width={12} height={12} />
              {optionsVisibility.calificacion && (
                <div className={styles.popover}>
                  {calificacionOptions.map((option) => (
                    <div
                      key={option.value}
                      className={styles.popoverItem}
                      onClick={() => handleCalificacionChange(option.value, option.label)}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </button>
          </div>
        </header>
        <section className={styles.content}>
            {userCalificationsLoading ? (
              <div className={styles.loadingContainer}>
                <RegisteredUserProfileLoader />
              </div>
            ) : (
              Array.isArray(userCalifications) ? (
                userCalifications.length === 0 ? (
                  <EmptyStateComments title={myPerson ? "No tienes calificaciónes" : "El usuario no ha recibido calificaciones"} />
                ) : (
                  (isFiltered ? commentsFiltered :
                  userCalifications).map((comment, index) => {
                    return (
                      <RepAndComments
                        key={`${myPerson}-${index}`}
                        comment={comment}
                      />
                    );
                  })
                )
              ) : null
            )}
        </section>
      </main>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    perfilAjeno: ownProps.perfilAjeno,
    projectId: ownProps.projectId,
    comments: state.profile.comments,
    commentsProfile: state.profile.comments,
    profileVisualizerData: state.general.profileVisualizer,
    userCalifications: state.profile.userCalifications,
    userCalificationsLoading: state.profile.userCalificationsLoading,
  };
};

export default connect(mapStateToProps, { openCalificationModal, getCalificationsByUser, })(MisComentarios);